"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _luxon = require("luxon");

var Trigger =
/** @class */
function () {
  function Trigger() {
    this.id = null;
    this.name = null;
    this.description = null;
    this.isActive = null;
    this.isOn = null;
    this.type = null;
    this.frequency = null;
    this.threshold = null;
    this.thresholdUnits = null;
    this.daysInAdvance = null;
    this.createdAt = null;
    this.updatedAt = null;
  }

  Trigger.thaw = function (triggerObj) {
    var _a, _b;

    if (triggerObj == null) return null;
    var trigger = new Trigger();

    if (triggerObj.id != null) {
      trigger.setId(triggerObj.id);
    }

    if (triggerObj.name != null) {
      trigger.setName(triggerObj.name);
    }

    if (triggerObj.description != null) {
      trigger.setDescription(triggerObj.description);
    }

    if (triggerObj.isActive != null) {
      trigger.setIsActive(triggerObj.isActive == null ? null : triggerObj.isActive ? true : false);
    }

    if (triggerObj.isOn != null) {
      trigger.setIsOn(triggerObj.isOn == null ? null : triggerObj.isOn ? true : false);
    }

    if (triggerObj.type != null) {
      trigger.setType(triggerObj.type);
    }

    if (triggerObj.frequency != null) {
      trigger.setFrequency(triggerObj.frequency);
    }

    if (triggerObj.threshold != null) {
      trigger.setThreshold(triggerObj.threshold);
    }

    if (triggerObj.thresholdUnits != null) {
      trigger.setThresholdUnits(triggerObj.thresholdUnits);
    }

    if (triggerObj.daysInAdvance != null) {
      trigger.setDaysInAdvance(triggerObj.daysInAdvance);
    }

    if (triggerObj.createdAt != null) {
      trigger.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(triggerObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (triggerObj.updatedAt != null) {
      trigger.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(triggerObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    return trigger;
  };

  Trigger.thawList = function (triggerObjList) {
    if (triggerObjList == null) {
      return [];
    }

    var triggers = [];

    for (var i = 0; i < triggerObjList.length; i++) {
      triggers.push(Trigger.thaw(triggerObjList[i]));
    }

    return triggers;
  };

  Trigger.freeze = function (trigger) {
    var _a, _b, _c, _d;

    if (trigger == null) {
      return null;
    }

    var triggerObj = {};

    if (trigger.getId() != null) {
      triggerObj.id = trigger.getId();
    }

    if (trigger.getName() != null) {
      triggerObj.name = trigger.getName();
    }

    if (trigger.getDescription() != null) {
      triggerObj.description = trigger.getDescription();
    }

    if (trigger.getIsActive() != null) {
      triggerObj.isActive = trigger.getIsActive() == null ? null : trigger.getIsActive() ? 1 : 0;
    }

    if (trigger.getIsOn() != null) {
      triggerObj.isOn = trigger.getIsOn() == null ? null : trigger.getIsOn() ? 1 : 0;
    }

    if (trigger.getType() != null) {
      triggerObj.type = trigger.getType();
    }

    if (trigger.getFrequency() != null) {
      triggerObj.frequency = trigger.getFrequency();
    }

    if (trigger.getThreshold() != null) {
      triggerObj.threshold = trigger.getThreshold();
    }

    if (trigger.getThresholdUnits() != null) {
      triggerObj.thresholdUnits = trigger.getThresholdUnits();
    }

    if (trigger.getDaysInAdvance() != null) {
      triggerObj.daysInAdvance = trigger.getDaysInAdvance();
    }

    if (trigger.getCreatedAt() != null) {
      triggerObj.createdAt = (_b = (_a = trigger.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (trigger.getUpdatedAt() != null) {
      triggerObj.updatedAt = (_d = (_c = trigger.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    return triggerObj;
  };

  Trigger.freezeList = function (triggers) {
    if (triggers == null) {
      return [];
    }

    var triggerObjList = [];

    for (var i = 0; i < triggers.length; i++) {
      triggerObjList.push(Trigger.freeze(triggers[i]));
    }

    return triggerObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Trigger.prototype.setId = function (id) {
    this.id = id;
  };

  Trigger.prototype.setName = function (name) {
    this.name = name;
  };

  Trigger.prototype.setDescription = function (description) {
    this.description = description;
  };

  Trigger.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };

  Trigger.prototype.setIsOn = function (isOn) {
    this.isOn = isOn;
  };

  Trigger.prototype.setType = function (type) {
    this.type = type;
  };

  Trigger.prototype.setFrequency = function (frequency) {
    this.frequency = frequency;
  };

  Trigger.prototype.setThreshold = function (threshold) {
    this.threshold = threshold;
  };

  Trigger.prototype.setThresholdUnits = function (thresholdUnits) {
    this.thresholdUnits = thresholdUnits;
  };

  Trigger.prototype.setDaysInAdvance = function (daysInAdvance) {
    this.daysInAdvance = daysInAdvance;
  };

  Trigger.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Trigger.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Trigger.prototype.getId = function () {
    return this.id;
  };

  Trigger.prototype.getName = function () {
    return this.name;
  };

  Trigger.prototype.getDescription = function () {
    return this.description;
  };

  Trigger.prototype.getIsActive = function () {
    return this.isActive;
  };

  Trigger.prototype.getIsOn = function () {
    return this.isOn;
  };

  Trigger.prototype.getType = function () {
    return this.type;
  };

  Trigger.prototype.getFrequency = function () {
    return this.frequency;
  };

  Trigger.prototype.getThreshold = function () {
    return this.threshold;
  };

  Trigger.prototype.getThresholdUnits = function () {
    return this.thresholdUnits;
  };

  Trigger.prototype.getDaysInAdvance = function () {
    return this.daysInAdvance;
  };

  Trigger.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Trigger.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  return Trigger;
}();

var _default = Trigger;
exports.default = _default;